// pages/Home/index.jsx
import React from "react";
import { HomeWrapper } from "./styles";
import Hero from "../../components/home/Hero";
import Features from "../../components/home/Features";
import CallToAction from "../../components/home/CallToAction";

const Home = () => {
	return (
		<HomeWrapper>
			<Hero />
			<Features />
			<CallToAction />
		</HomeWrapper>
	);
};

export default Home;
